import { selectAllLiquidityOneOffCashflowItems } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySelectAllMutation } from './use-liquidity-select-all-mutation';

export const useSelectAllLiquidityOneOffCashflowItems = () =>
    useLiquiditySelectAllMutation({
        mutationFn: (clientId, selected) => selectAllLiquidityOneOffCashflowItems({ query: { clientId, selected } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityOneOffCashflowSettings,
    });
